$(function(){
    $(".accordion-heading").click(function(){
        if($(this).next(".accordion-content").css("display") != "none"){
            $(this).next(".accordion-content").slideUp();
            $(this).next(".accordion-content").parent().removeClass("active");
        } else {
            $(this).next(".accordion-content").slideDown();            
            $(this).next(".accordion-content").parent().addClass("active");
        }

        $(".accordion-content").not($(this).next(".accordion-content")).slideUp();
        $(".accordion-content").not($(this).next(".accordion-content")).parent().removeClass("active");
        
    })
})